export function trackEvent(name, params = {}) {
  if (typeof gtag !== "function") return
  gtag("event", name, params)
}

export function trackCta(ctaId, params = {}) {
  trackEvent("cta_click", { cta_id: ctaId, ...params })
}
